export default __webpack_public_path__ + "static/media/butterfly.8b5a29a0.png";